import { render, staticRenderFns } from "./CFEMandateList.vue?vue&type=template&id=2bd94898&"
import script from "./CFEMandateList.vue?vue&type=script&lang=ts&"
export * from "./CFEMandateList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports